import React from 'react';
import { Col, Row } from "react-bootstrap";
import { makeStyles, Button, Box } from "@material-ui/core";
import IconHolder from '../../Common/IconHolder';
import { NeedsAnalysisList } from '../../Helpers/Lists/NeedsAnalysisList';
import { ADVISOR_OBJECT_KEY, getSessionStorageItem, SESSION_STORAGE_NEEDS_ANALYSIS_KEY } from '../../../sessionStorage';
import { v4 as uuid } from 'uuid';
import { useHistory } from 'react-router-dom';
import "../ResourceCenter.scss";

const ResourceTools = ({ searchState, updateSearch }) => {
  const css = useStyles();
  const history = useHistory();

  const redirectToLandingPage = (path) => {
    if (path) {
      sessionStorage.removeItem(SESSION_STORAGE_NEEDS_ANALYSIS_KEY);
      history.push(path);
    }
  }
  const advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
  const insuranceSpecialistURL = advisorObj && advisorObj.insuranceSpecialistURL;

  const generateInsuranceSpecialistUrl = () => {
    const uniqueID = uuid();
    return `${insuranceSpecialistURL}?ApplicationID=${uniqueID}`;
  }

  return (
    <div className={css.toolsContainer}>
      <Row>
        <Col>
          <h4><b>Insurance Tools</b></h4>
        </Col>
      </Row>
      <Row className='insurance-products'>
        {NeedsAnalysisList.map((item, index) => (
          !item.isShowOnlyOnHomePage &&
          <Col key={index} className={`pb-5 ${index !== 2 ? 'pr-1' : ''}`}>
            <div className='main-product mt-0'>
              <div
                style={{ backgroundImage: `linear-gradient(150deg, #F9FBFD 0%, #F9FBFD 22%, #F9FBFD00 33%) ,url(${item.imageUrl})` }}
                className='background-image-resources-class'>
                <div className='ml-5'>
                  <Row className='mt-4'>
                    <IconHolder icon={item.icon} viewBox="0 0 25 25" />
                  </Row>
                  <Row className='mt-2'>
                    <Box className='toolBoxTitle'>
                      {item.name}
                    </Box>
                  </Row>
                  <Row>
                    <p className='toolBoxSubTitle'>{item.subText || ' '}</p>
                  </Row>
                  <Row className='mt-0 mb-5'>
                    {item.key === 'available-products' ?
                      <a href={item.href} target={item.target}><Button color="primary" variant="contained" className='toolStartButton'>OPEN</Button></a>
                      :
                      <Button color="primary" variant="contained" className='toolStartButton' onClick={() => redirectToLandingPage(`${item.href}`)}>START</Button>
                    }
                  </Row>
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
      <Row>
        <Col>
          <h4><b>Key Business Contacts</b></h4>

          <div className={'supportLink'}>
            <b>Insurance Platform Assistance</b> <br />
            Order entry support for annuity and life insurance products. <br />
            <a href={'tel:8442016080'} className={css.highlight}>844-201-6080</a>
          </div>

          <div className={'supportLink'}>
            <b>MS Operational Support</b> <br />
            Service support for state licensing requirements, carrier appointments, and continuing education. <br />
            <a href={'tel:8004905412'} className={css.highlight}>800-490-5412</a>
          </div>

          <div className={'supportLink'}>
            <b>Annuity & Insurance Sales Desk</b> <br />
            Post-policy issue support, networking, and statements for annuity and insurance products. <br />
            <a href={'tel:9142257404'} className={css.highlight}>914-225-7404</a>
          </div>

          <div className={'supportLink'}>
            <b>Key Support Links</b> <br />
            Key Support Links <br />
            <a href={generateInsuranceSpecialistUrl()} className={css.highlight}>Insurance Specialist</a>
          </div>
        </Col>
      </Row>
      {/* <Row>
        <Col>
          <div className={'filterContainer'}>
            <TextInput label={'Search Resources'} value={searchState} id={'search'} name={'search'} fullWidth={false}
                       placeholder={'Type here'} onChange={(e) => updateSearch(e.target.value)}/>
          </div>
        </Col>
      </Row> */}
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  toolsContainer: {
    padding: '15px 30px 15px 30px',
    '& .supportLink': {
      paddingTop: 8
    },
    '& .filterContainer': {
      display: 'flex',
      '& div:first-child': {
        marginRight: '6em'
      }
    },
    '& .buttonContainer': {
      display: 'inline-flex',
      '& div:first-child': {
        paddingLeft: 0
      }
    }
  },
  highlight: {
    color: theme.palette.primary.main,
    fontWeight: 'bold'
  }
}));

export default ResourceTools;


// WEBPACK FOOTER //
// ./src/components/Resource Center/SubComponents/ResourceTools.js